import api from "./api";


export const fraseMotivacional = async () => {
  const response = await api.get(`frase_motivacional`);
  return response.data;
}

// export const comunicadosGenerales = async () => {
//   const response = await api.get(`endpoint`);
//   return response.data;
// }

export const comunicadosGenerales = async () => {
  // Simulamos una espera de la petición
  await new Promise(resolve => setTimeout(resolve, 1000));
  // Devolvemos true
  return true;
}
